import { toast } from 'react-toastify';

const requestLoginType = 'REQUEST_LOGIN';
const receiveLoginType = 'RECEIVE_LOGIN';
const signOutType = 'SIGN_OUT';

const initialState = {
    auth: {
        user: JSON.parse(localStorage.getItem('user')), token: localStorage.getItem('token')
    },
    isLoading: false,
    isAuthenticated: localStorage.getItem('user') !== null,
    authFailed: false,
    userRole: (JSON.parse(localStorage.getItem('user'))) ? JSON.parse(localStorage.getItem('user')).role : '',
    allowSameDayDeliveries: false
};

export const actionCreators = {
    requestLoginToken: (username, password) => async (dispatch, getState) => {

        dispatch({ type: requestLoginType, username, password });

        const url = `api/token/tokenlogin`;
        const fetchConfig = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify({ username: username, password: password })
        };
        const response = await fetch(url, fetchConfig);
        if (response.ok) {

            const auth = await response.json();

            // should this go in the reducer code? [BDL - I don't think so, might be timing issues]
            let user = JSON.stringify(auth.user);
            localStorage.setItem('user', user);
            localStorage.setItem('token', auth.token);

            const fetchConfig = {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            };
            const response2 = await fetch('api/OrderGuideGroups/settings', fetchConfig);
            if (response2.ok) {
                let data = await response2.json();

                dispatch({ type: receiveLoginType, auth, data });
            }
            else {
                toast.error(`Error fetching Order Guide settings.`);
                console.log("Error retrieving Order Guide Groups: " + await response2.text());
            }           
        }
        else if (response.status === 401) {
            toast.error("Invalid User Name or Password.");
            dispatch({ type: receiveLoginType, auth: initialState.auth, authFailed: true });
        }
        else {
            let msg = await response.text();
            toast.error(msg);
            dispatch({ type: receiveLoginType, auth: initialState.auth, authFailed: true });
        }

    },
    signOut: () => async (dispatch, getState) => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        dispatch({ type: signOutType });
    }
};

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === requestLoginType) {
        return {
            ...state,
            isLoading: true
        };
    }

    if (action.type === receiveLoginType) {
        let user = JSON.parse(localStorage.getItem('user'));
        return {
            ...state,
            auth: action.auth,
            isLoading: false,
            isAuthenticated: action.auth.user !== null,
            authFailed: action.auth.user === null,
            userRole: (user) ? user.role : '',
            allowSameDayDeliveries: (action.data) ? action.data.orderGuideGroup.allowSameDayDeliveries : false
        };
    }

    if (action.type === signOutType) {
        return {
            ...state,
            isAuthenticated: false,
            authFailed: false,
            auth: null
        };
    }

    return state;
};



// WEBPACK FOOTER //
// ./src/store/Login.js